import classNames from 'classnames'
import React, { ReactElement } from 'react'
import { useStableId } from '../../utils'
import styles from './index.module.css'

export function FormToggle({
  id,
  className,
  style,
  'aria-label': ariaLabel,
  ...props
}: React.HTMLProps<HTMLInputElement>): ReactElement {
  const stableId = useStableId()
  const toggleId = id || stableId
  return (
    <div className={classNames('flex', 'gap-2', className)} style={style}>
      <span className={styles.toggle}>
        <input type="checkbox" id={toggleId} {...props} />
        <label htmlFor={toggleId} aria-label={ariaLabel} />
      </span>
    </div>
  )
}
